module.exports = __webpack_public_path__ + "img/battle_section1_item1.33b1118e.png";